
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faChevronRight as fasChevronRight,
    } from '@fortawesome/pro-solid-svg-icons/faChevronRight';

    export default {
        name: 'JobViewSubtitle',

        components: {
            FontAwesomeIcon,
        },

        props: {
            companyName: {
                type: String,
                default: '',
            },

            companyLink: {
                type: String,
                default: '',
            },
            primaryCompanyName: {
                type: String,
                default: '',
            },

            primaryCompanyLink: {
                type: String,
                default: '',
            },

            displayPrimaryBrandCrumb: {
                type: Boolean,
                default: false,
            },

            locationLabel: {
                type: String,
                default: '',
            },

            locationLink: {
                type: String,
                default: '',
            },

            isPrivateListing: {
                type: Boolean,
                default: false,
            },

            stacked: {
                type: Boolean,
                default: false,
            },

            textSizeClass: {
                type: String,
                default: 'text-body-3',
            },
        },

        data() {
            return {
                icons: {
                    fasChevronRight,
                },
            };
        },

        computed: {
            companyNameLabel() {
                return this.isPrivateListing ? 'Private Listing' : this.companyName;
            },
        },
    };
